import CategoryAPI from "@api/lol/Category.api";
import type IProduct from "@api/models/IProduct";
import AccountDisplay from "@core-components/accountDisplay/AccountDisplay";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import type React from "react";
import { useCallback, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import SSProductCard from "./SSProductCard";

export const SSHandlevelWidget: React.FC = () => {
  const { t } = useAppTranslation("components.handlevelWidget");
  const [handLevelProducts, setHandLevelProducts] = useState<IProduct[]>([]);
  const { regionUrlBuilder } = useAppRegion();
  const { lang } = useAppLanguage();

  const loadData = useCallback(() => {
    CategoryAPI.getHandlevelProducts({ normalized: true }).then(
      setHandLevelProducts,
    );
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData, lang.currentLanguage]);

  return (
    <AccountDisplay.Carousel
      emoji="Sparkles"
      href={regionUrlBuilder(EPublicRoutes.SMURFS_HANDLEVEL)}
      label={
        <Trans t={t} i18nKey="title">
          <SSWhiteText> COMPTES </SSWhiteText>
          <SSLoLGradientText>MONTÉS MAIN</SSLoLGradientText>
        </Trans>
      }
      title={t("viewAll")}
      onRegionChange={() => {
        loadData();
      }}
    >
      {handLevelProducts.map((product, index) => (
        <SSProductCard
          key={`${product.id}-${index}`}
          product={product}
          header={t("productHeader")}
        />
      ))}
    </AccountDisplay.Carousel>
  );
};
